// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDZyWuJgzihU7m89y5H2qCsLLT4ZgZAWPA",
    authDomain: "potent-odyssey-273014.firebaseapp.com",
    databaseURL: "https://potent-odyssey-273014.firebaseio.com",
    projectId: "potent-odyssey-273014",
    storageBucket: "potent-odyssey-273014.appspot.com",
    messagingSenderId: "491498255461",
    appId: "1:491498255461:web:877e99d26dd606353ec28c",
    measurementId: "G-D4RR4JJ8M2"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
